// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"006eca3f","455":"5828ce17","977":"2813b594"}[chunkId] + ".chunk.js";
};